export default "__VITE_ASSET__ZG7KsqXr__"